export default __webpack_public_path__ + "static/media/driver-white.3249947e.svg";